import { useSelector } from '../hook-utils';
import { DeviceGroupType, ExtensionStatus, Presence, Identifier } from '../model';
import { selectExtension } from '../store/reducers/queueAgents';
import CallStatusIcon from './CallStatusIcon';
import { ReactComponent as QueueAway } from './icons/presence/presence-queue-away.svg';
import { ReactComponent as QueueDisabled } from './icons/presence/presence-queue-disabled.svg';
import { ReactComponent as WrapupIcon } from './icons/presence/presence-wrapup.svg';
import { ReactComponent as OffHookOutbound } from './icons/callstatus/off-hook-outbound.svg';
import PresenceIcon from './PresenceIcon';
import { HasClassName } from '../component-utils';


interface ExtensionProps extends HasClassName {
  id: Identifier, enabled?: boolean
}

export default function ExtensionIcon({ id, enabled }: ExtensionProps) {
  const extension = useSelector(s => selectExtension(s, id))
  if (!extension) { return <></> }

  
    if (extension.status === ExtensionStatus.Released || extension.status === ExtensionStatus.Invalid || extension.status === ExtensionStatus.Swapped || extension.status === ExtensionStatus.None) {
      if (extension.activity.length > 0) {
        return <OffHookOutbound/>
      } else  if (extension.waitingForWrapup) {
        return <WrapupIcon />
      } else if (extension.presence === Presence.Queue) {
        if (enabled !== undefined && enabled === false) {
          return <QueueDisabled />
        } else if (extension.tempLogout) {
          return <QueueAway />
        }
      }
      const deviceGroupType = extension.extendedAvailablePresence ? extension.deviceGroupType : DeviceGroupType.None;

      return <PresenceIcon presence={extension.presence} deviceGroupType={deviceGroupType} awayFromDesk={extension.awayFromDesk} />
    } else {
      return <CallStatusIcon presence={extension.presence} status={extension.status} subStatus={extension.subStatus} />
    }
  }
